import { createTheme } from '@mui/material/styles';

import {
  brandAccent,
  color,
  extendFoundation,
  foundationPalette,
  foundationTypography,
} from './foundation';
import { withMobileComponents } from './mobileOverrides';

/**
 * Worker portal theme (`/worker/*`). Until 1.0d the worker portal ran on the
 * admin theme; it now shares the client portal's foundation (contrast-checked
 * colours, 16 px body, focus ring, touch targets, reduced motion) and, since
 * decision F1, the same brand: the orange fill with dark text, the dark
 * orange as text and focus colour. The heading scale and corner radius are the admin ones it was laid
 * out with, so worker pages keep their proportions — only colour, focus and
 * touch behaviour change.
 */
export const workerTheme = createTheme({
  palette: foundationPalette(brandAccent),
  typography: {
    ...foundationTypography,
    h1: { fontSize: 'clamp(1.5rem, 1.2rem + 1.5vw, 2rem)', fontWeight: 600, lineHeight: 1.25 },
    h2: { fontSize: 'clamp(1.2rem, 1rem + 1vw, 1.5rem)', fontWeight: 600, lineHeight: 1.3 },
    h3: { fontSize: 'clamp(1rem, 0.95rem + 0.4vw, 1.125rem)', fontWeight: 600, lineHeight: 1.4 },
    h4: { fontSize: '1rem', fontWeight: 600, lineHeight: 1.4 },
    h5: { fontSize: '0.9375rem', fontWeight: 600, lineHeight: 1.4 },
    h6: { fontSize: '0.875rem', fontWeight: 600, lineHeight: 1.4 },
  },
  shape: { borderRadius: 8 },
  components: withMobileComponents(extendFoundation(color.brand)),
});
